module.exports = __webpack_public_path__ + "img/product16.c4483ecf.png";